export default __webpack_public_path__ + "static/media/icondemo.de7611ce.png";